import { filter, map, switchMap, take } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ILegalEntity } from '@cemex-core/cmx-api/models/legal-entities/legal-entity';
import { TimeWindowsReq, TimeWindowsRes } from '@cemex-core/cmx-api/models/time-windows';
import { OrderBuilderState } from '../../../../reducers';
import { BusinessLinesState } from '../../../business-line-selection/reducers/business-line/business-lines.reducer';
import { PlantsService, TimeWindowsService, Plant } from '@cemex-core/cmx-api';
import { ShippingConditionsState } from '../../../business-line-selection/reducers/shipping-condition/shipping-conditions.reducer';
import {
  LoadTimeWindowsCompleteAction,
  LoadTimeWindowsFromPlantAction,
  BULK_CEM_UL_LOAD_TIME_WINDOWS_FROM_PLANT,
} from '../../actions/time-windows.actions';
import {
  LS_SALES_AREA_LOAD_COMPLETE,
  SalesAreaLoadCompleteAction,
} from '../../actions/jobsite-actions/jobsite.actions';
import { Store } from '@ngrx/store';
import { getFieldsForLoadingCatalogsWhitExperience } from '../../selectors';
import { ORDER_EXPERIENCES } from '../../../../../shared/constants/order-experiences';
import { _safe } from '@ordersnproducts/modules/shared/utils/safe-get.method';

@Injectable()
export class TimeWindowsFromPlantLocationSpecificationEffects {
  specificationConfigLoadComplete = createEffect(() =>
    this.actions$.pipe(
      ofType(LS_SALES_AREA_LOAD_COMPLETE),
      switchMap(({ payload }: SalesAreaLoadCompleteAction) => {
        const plantId = payload.salesAreas.jobsiteSalesAreas[0].plant.plantId;
        return this.plantsService.getPlant(plantId).pipe(map((plant: Plant) => plant.plantCode));
      }),
      switchMap((plantCode: string) => {
        return this.store.select(getFieldsForLoadingCatalogsWhitExperience).pipe(
          take(1),
          filter(
            (fluid) =>
              _safe(() => fluid.selectedExperience.experiences[0].experienceCode) === ORDER_EXPERIENCES.REQUEST,
            false,
          ),
          map(
            (result: {
              customer: ILegalEntity;
              businessLineState: BusinessLinesState;
              shippingContitionState: ShippingConditionsState;
              selectedExperience;
            }) => {
              return new LoadTimeWindowsFromPlantAction({
                countryCode: result.customer.countryCode,
                productLineCode: result.businessLineState.selected.productTypeCode,
                plantCode: plantCode,
                shippingConditionCode: result.shippingContitionState.selected.shippingConditionCode,
                customerCode: result.customer.legalEntityCode
                  ? result.customer.legalEntityCode
                  : result.customer.legalEntityTypeCode,
              } as TimeWindowsReq);
            },
          ),
        );
      }),
    ),
  );
  // LOAD_TIME_WINDOWS_REQUEST_COMPLETE

  timeWindowLoad = createEffect(() =>
    this.actions$.pipe(
      ofType(BULK_CEM_UL_LOAD_TIME_WINDOWS_FROM_PLANT),
      switchMap((payload: LoadTimeWindowsFromPlantAction) => {
        return this.timeWindowsService.getTimeWindows(payload.payload).pipe(
          map((response: TimeWindowsRes) => {
            return new LoadTimeWindowsCompleteAction(response.timewindows);
          }),
        );
      }),
    ),
  );

  constructor(
    private actions$: Actions,
    private store: Store<OrderBuilderState>,
    private timeWindowsService: TimeWindowsService,
    private plantsService: PlantsService,
  ) {}
}
